/* CUBE STORE - carrello

   1) tasto per passare al carrello a tutta pagina dalla barra laterale;
   2) riga "Taglia M - Codice 117400" sotto il nome dell'articolo;
   3) riepilogo con articoli, prenotazione, da pagare ora e saldo.

   I totali del riepilogo NON sono calcolati qui: arrivano gia' formattati
   dall'isola dati, dove "da pagare ora" e' cart.total_price, cioe' quello
   che incassera' davvero il checkout. Se non c'e' nessun acconto attivo,
   hasDeposit e' false e le righe del saldo non vengono mostrate: meglio un
   riepilogo piu' povero che un numero che il checkout non conferma.

   Il tema ridisegna il contenuto a ogni modifica del carrello, quindi tutto
   va rimesso: ci pensa l'osservatore. */
(function () {
  var FULL_LABEL = 'Visualizza carrello';

  var ICON =
    '<svg viewBox="0 0 24 24" aria-hidden="true">' +
    '<path d="M15 3h6v6M21 3l-7 7M9 21H3v-6M3 21l7-7"/>' +
    '</svg>';

  var NOTE =
    'Il saldo non viene addebitato automaticamente. Ti contattiamo noi quando ' +
    'la bici arriva in sede e concordiamo il pagamento del restante 90%.';

  function data() {
    var node = document.getElementById('cube-preorder-data');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  /* ---------- tasto "visualizza carrello" nella barra laterale ---------- */

  function placeButton() {
    var drawer = document.querySelector('.cart-drawer__dialog');
    if (!drawer) return;

    var ctas = drawer.querySelector('.cart__ctas');
    if (!ctas || ctas.querySelector('.cube-cart-full')) return;

    var link = document.createElement('a');
    link.className = 'cube-cart-full';
    link.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart'
      : '/cart';
    link.innerHTML = ICON + '<span>' + FULL_LABEL + '</span>';

    ctas.insertBefore(link, ctas.firstChild);
  }

  /* ---------- riga taglia + codice ---------- */

  function placeMeta(payload) {
    payload.lines.forEach(function (line) {
      document.querySelectorAll('tr[data-key="' + line.key + '"]').forEach(function (row) {
        if (row.dataset.cubeMeta === '1') return;
        row.dataset.cubeMeta = '1';

        var wrap = row.querySelector('.cart-items__variants-wrapper');
        if (!wrap) return;

        var bits = [];
        if (line.size) bits.push('Taglia ' + line.size);
        if (line.code) bits.push('Codice ' + line.code);

        if (bits.length) {
          var meta = document.createElement('p');
          meta.className = 'cube-cart-meta';
          meta.textContent = bits.join(' · ');
          wrap.insertBefore(meta, wrap.firstChild);
        }

        /* il prezzo unitario dentro i dettagli e' identico al totale di riga
           quando la quantita' e' 1: in quel caso e' solo un doppione */
        var unit = row.querySelector('.cart-items__unit-price-wrapper');
        if (unit && line.quantity <= 1) unit.hidden = true;
      });
    });
  }

  /* ---------- riepilogo ---------- */

  function row(label, value, variant) {
    return (
      '<div class="cube-sum__row' + (variant ? ' cube-sum__row--' + variant : '') + '">' +
      '<span>' + label + '</span><b>' + value + '</b>' +
      '</div>'
    );
  }

  function placeSummary(payload) {
    var cart = payload.cart;
    if (!cart) return;

    document.querySelectorAll('.cart-summary__inner').forEach(function (inner) {
      var old = inner.querySelector('.cube-sum');
      if (old) old.remove();

      var block = document.createElement('div');
      block.className = 'cube-sum';

      var html =
        '<p class="cube-sum__title">Riepilogo</p>' +
        row('Articoli (' + cart.itemCount + ')', cart.full);

      if (cart.hasPreorder) {
        html += row('di cui in prenotazione', cart.preorderFull, 'muted');
      }

      html += row('Spedizione', '<span class="cube-sum__free">Gratuita</span>');

      html +=
        '<div class="cube-sum__divider"></div>' +
        '<div class="cube-sum__now">' +
          '<span>Da pagare ora</span><strong>' + cart.payNow + '</strong>' +
        '</div>';

      if (cart.hasDeposit) {
        if (cart.hasInStock) {
          html += '<p class="cube-sum__breakdown">acconto ' + cart.deposit +
                  ' + articoli disponibili ' + cart.inStock + '</p>';
        }
        html += '<div class="cube-sum__balance"><span>Saldo alla disponibilità</span><b>' +
                cart.balance + '</b></div>';
      }

      block.innerHTML = html;
      inner.insertBefore(block, inner.firstChild);

      /* nota sotto i pulsanti, solo quando c'e' davvero un saldo da versare */
      var ctas = inner.querySelector('.cart__ctas');
      if (ctas) {
        var note = ctas.querySelector('.cube-sum__note');
        if (cart.hasDeposit) {
          if (!note) {
            note = document.createElement('p');
            note.className = 'cube-sum__note';
            note.textContent = NOTE;
            ctas.appendChild(note);
          }
        } else if (note) {
          note.remove();
        }
      }

      /* etichetta del pulsante con l'importo davanti agli occhi */
      var label = inner.querySelector('.cart__checkout-button .button-text');
      if (label) label.textContent = 'Procedi al pagamento · ' + cart.payNow;
    });
  }

  function run() {
    placeButton();

    var payload = data();
    if (!payload) return;

    placeMeta(payload);
    placeSummary(payload);
  }

  function init() {
    run();

    var root = document.querySelector('cart-items-component') || document.body;
    new MutationObserver(function () {
      requestAnimationFrame(run);
    }).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
